<template>
  <div v-if="fileList.length>0">
    <base-tag label="扫描杆和替代体数据库历史上传"></base-tag>
    <div v-if="loading" class="loading-container">
      <i class="el-icon-loading"></i>
      <span>正在加载数据...</span>
    </div>
    <div class="file-history" v-else>
      <el-tag v-for="(item, index) in fileList" :key="index" @click="pushData(item)"
       style="margin: 5px 5px;">
       {{ item.name }}
        <el-button
          class="btn-download"
          type="text"
          icon="el-icon-download"
          @click.stop="downFile(item)"
        />
      </el-tag>
    </div>
  </div>
</template>
<script>
import BaseTag from '/components/BaseTag';
export default {
  name: 'FileHistory',
  data(){
    return{
      fileList:[],
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 1000,
      }
    }
  },
  props: {
    dataField: {
      type: String,
      default: 'dataScanRod'
    },
  },
  mounted() {
    this.loadHistory();
  },
  methods: {
    // 获取全部订单
    loadHistory(){
      if (this.loading) return;
      this.loading = true;
      this.$api.get({
        url: '/biz/orderServ/dem/order',
        data: this.queryParams
      }).then(res => {
        if(res && Array.isArray(res.rows)){
          res.rows.forEach(item => {
            try {
              if(item[this.dataField]&&JSON.parse(item[this.dataField]).length>0){
                this.toArray(item[this.dataField]);
              }
            } catch (error) {
              console.log('解析数据失败：',error);
            }
          });
        }
      }).catch(e =>{
        console.log('获取数据失败：',e);
      }).finally(()=>{
        this.loading = false;
      });
    },
    /**
     * 解析JSON数据
     * @param {string} value - 需要解析的JSON字符串
     */
    toArray(value){
      try{
        let json = JSON.parse(value);
        this.queryDuplication(json);
      } catch(e) {
        console.log('error',e)
      }
    },
    /**
     * 数据去重
     * @param {Object} array - 判断是否重复的数据
     */
    queryDuplication(array){
      array.forEach(item => {
        const isDuplicate = this.fileList.some(fileItem =>{
          return fileItem.name === item.name;
        });
        if(!isDuplicate&&this.fileList.length<20){
          this.fileList.push(item);
        }
      });
    },
    /**
     * 向父组件传递数据，父组件list添加数据
     * @param {Object} item - 传递给父组件的数据
     */
    pushData(item) {
      this.$emit('push-data', item)
    },
    /**
     * 下载文件
     * @param {Object} item
     */
    downFile(item) {
      var loading = this.$loading({
        text:'正在下载，已下载0%'
      });
      const xhr = new XMLHttpRequest();
      xhr.open('GET',item.url,true);
      xhr.responseType = 'blob';
      // 监听进度事件
      xhr.onprogress = (e) => {
        if(e.lengthComputable){
          const percentComplete = (e.loaded / e.total) * 100;
          loading.setText('正在下载，已下载' + percentComplete.toFixed(2) + '%')
        }
      }
      xhr.onload = function(){
        if(xhr.status === 200){
          const blob = xhr.response;
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = blobUrl;
          a.download = item.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
          loading.close();
        }else{
          loading.close();
          console.error('下载失败，状态码',this.status);
        }
      }
      xhr.onerror = function(){
        loading.close();
        console.error('Error downloading the file.');
      }
      xhr.send();
    }
  },
  components: {
    BaseTag
  },
}
</script>
<style scoped lang="scss">
.file-history{
  width: 100%;
  display: flexbox;
}
.btn-download{
  border: none;
  padding: 3px;
  margin-left: 4px;
  border-radius: 50%;
  display: inline-block;
}
.btn-download:hover{
  color: white;
  background-color: #409eff;
}
.el-tag:hover{
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// fileHistory.vue?3a11cf8c